import { AffiliateEarnings, PaymentSettings, ShowHeader } from "@/components";
import { Button, Divider, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useUIStore } from "@/stores";
import { CreatePayout } from "@/features/affiliate-payouts/modals";
import { useParams } from "react-router-dom";
import { useGetAffiliateUser } from "@/features/affiliate-users/queries";
import { Loading } from "react-admin";
import { Payouts } from "@/features/affiliate-payouts/components";

const PaymentShow: FC = () => {
  const { id: affiliateId } = useParams();
  const { openModal } = useUIStore();

  const { affiliate, isAffiliateLoading } = useGetAffiliateUser(
    affiliateId ?? "",
  );

  if (isAffiliateLoading || !affiliate) {
    return <Loading />;
  }

  const {
    bankAccountCredentials,
    fullName,
    alphaReferralPaymentBps,
    museReferralPaymentCents,
  } = affiliate;

  return (
    <Stack direction={"column"} p={2}>
      <ShowHeader
        title="Affiliate"
        rightAddon={
          <Button
            variant="contained"
            color="secondary"
            onClick={() =>
              openModal(CreatePayout, {
                title: "Create Payout",
                affiliateId: affiliate.id,
              })
            }
          >
            Create Payout
          </Button>
        }
      />

      <Stack spacing={2}>
        <Typography variant="h6" fontWeight="bold">
          {fullName}
        </Typography>
        <Divider sx={{ margin: "16px 0" }} />
        <PaymentSettings
          alphaReferralPaymentBps={alphaReferralPaymentBps}
          museReferralPaymentCents={museReferralPaymentCents}
          bankAccountCredentials={bankAccountCredentials}
        />
        <Divider sx={{ margin: "16px 0" }} />

        <AffiliateEarnings affiliateId={affiliate.id}/>
        <Payouts />
      </Stack>
    </Stack>
  );
};

export { PaymentShow };
